import { makeI18nField } from "../utils/i18nSchemas";

export const createRegistrationCustomFieldSchema = {
  body: {
    type: "object",
    required: ["eventId", "labelI18n", "key", "type", "required", "appliedTo"],
    properties: {
      eventId: { type: "integer" },
      labelI18n: makeI18nField({ required: true, minLength: 1 }),
      key: { type: "string", pattern: "^[A-Za-z0-9_]+$", minLength: 1 },
      type: {
        type: "string",
        enum: ["text", "boolean", "select", "multiselect", "date", "country"],
      },
      required: { type: "boolean" },
      options: {
        type: "array",
        items: {
          type: "object",
          required: ["nameI18n"],
          properties: {
            nameI18n: makeI18nField({
              required: true,
              minLength: 1,
            }),
          },
          additionalProperties: false,
        },
      },
      appliedTo: { type: "string", enum: ["registrations", "ticket"] },
      showOnRegistrationForm: { type: "boolean" },
    },
  },
};

export const getAllRegistrationCustomFieldsSchema = {
  querystring: {
    type: "object",
    required: ["eventId"],
    properties: {
      eventId: { type: "integer" },
    },
  },
};

export const updateRegistrationCustomFieldSchema = {
  params: {
    type: "object",
    required: ["id"],
    properties: {
      id: { type: "integer" },
    },
  },
  body: {
    type: "object",
    properties: {
      labelI18n: makeI18nField({ required: true, minLength: 1 }),
      key: { type: "string", pattern: "^[A-Za-z0-9_]+$", minLength: 1 },
      type: {
        type: "string",
        enum: ["text", "boolean", "select", "multiselect", "date", "country"],
      },
      required: { type: "boolean" },
      showOnRegistrationForm: { type: "boolean" },
      options: {
        anyOf: [
          { type: "null" },
          {
            type: "array",
            items: {
              type: "object",
              required: ["nameI18n"],
              properties: {
                nameI18n: makeI18nField({
                  required: true,
                  minLength: 1,
                }),
              },
              additionalProperties: false,
            },
          },
        ],
      },
    },
  },
};

export const deleteRegistrationCustomFieldSchema = {
  params: {
    type: "object",
    required: ["id"],
    properties: {
      id: { type: "integer" },
    },
  },
};

export const web_createRegistrationCustomFieldSchema =
  createRegistrationCustomFieldSchema.body;

export const web_updateRegistrationCustomFieldSchema =
  updateRegistrationCustomFieldSchema.body;
